import { render, staticRenderFns } from "./ResponsiveHandler.vue?vue&type=template&id=27d7422f&scoped=true&"
import script from "./ResponsiveHandler.vue?vue&type=script&lang=js&"
export * from "./ResponsiveHandler.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveHandler.vue?vue&type=style&index=0&id=27d7422f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7422f",
  null
  
)

export default component.exports